// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: lato, sans-serif;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Thin scrollbar */
::-webkit-scrollbar {
  width: 6px; /* Adjust thickness */
  height: 6px;
}

/* Scrollbar track */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* Light grey background */
  border-radius: 10px;
}

/* Scrollbar thumb */
::-webkit-scrollbar-thumb {
  background: #888; /* Darker grey thumb */
  border-radius: 10px;
}

/* Scrollbar thumb on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* Even darker grey */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,6BAA6B;EAC7B;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,mBAAmB;AACnB;EACE,UAAU,EAAE,qBAAqB;EACjC,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB,EAAE,sBAAsB;EACxC,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB,EAAE,qBAAqB;AACzC","sourcesContent":["body {\n  margin: 0;\n  font-family: lato, sans-serif;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Thin scrollbar */\n::-webkit-scrollbar {\n  width: 6px; /* Adjust thickness */\n  height: 6px;\n}\n\n/* Scrollbar track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Light grey background */\n  border-radius: 10px;\n}\n\n/* Scrollbar thumb */\n::-webkit-scrollbar-thumb {\n  background: #888; /* Darker grey thumb */\n  border-radius: 10px;\n}\n\n/* Scrollbar thumb on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Even darker grey */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
